import { HttpClient, HttpHeaders, HttpResponse } from "@angular/common/http";
import { Injectable, OnDestroy, OnInit } from "@angular/core";
import { BehaviorSubject, map, Observable } from "rxjs";
import { PDFTemplate } from "src/app/models/PDFTemplate.model";
import { environment } from "src/environments/enviroment";

/**
 * Exported so the reset path and the constructor cannot drift apart — a cart
 * needs the text-field data cleared between configurations, and it has to be
 * cleared back to exactly this shape.
 */
export const DEFAULT_TEXT_FIELD_DATA = {
  DATE: '',
  DOCUMENT_Nr: '',
  CUSTOMER: '',
  PLACE: '',
  SYSTEM_QUANTITY: 1,
  GLASSES: null,
  COMMENT: null,
  NETAMNT: '',
  SUMAMNT: '',
  VATAMNT: '',
  FINDOC_QUANTITY: 1
};

@Injectable({
  providedIn: 'root'

})

export class PDFService implements OnInit,OnDestroy {
  environment: any;
  private apiUrl = `${environment.apiLink}/pdf-templates/`;
  private _selectedTemplate: PDFTemplate | null = null;
  private selectedTemplateSubject: BehaviorSubject<PDFTemplate | null> = new BehaviorSubject<PDFTemplate | null>(null);
  private selectedTemplatesSubject: BehaviorSubject<PDFTemplate[]> = new BehaviorSubject<PDFTemplate[]>([]);
  private textFieldDataSubject = new BehaviorSubject<any>({ ...DEFAULT_TEXT_FIELD_DATA });


  constructor(private http: HttpClient) { }

  ngOnInit(): void {

  }

  setSelectedTemplates(templates: PDFTemplate[]): void {
    this.selectedTemplatesSubject.next(templates);
  }

  // Observable to allow other components to subscribe.
  getSelectedTemplates(): Observable<PDFTemplate[]> {
    return this.selectedTemplatesSubject.asObservable();
  }

  // Optional synchronous getter.
  getCurrentSelectedTemplates(): PDFTemplate[] {
    return this.selectedTemplatesSubject.getValue();
  }
  /**
   * Synchronous getter for the selected template.
   */
  getCurrentSelectedTemplate(): PDFTemplate | null {
    return this._selectedTemplate;
  }

  setTextFieldData(data: any): void {
    this.textFieldDataSubject.next(data);
  }

  getTextFieldData(): Observable<any> {
    return this.textFieldDataSubject.asObservable();
  }

  getCurrentTextFieldData(): any {
    return this.textFieldDataSubject.getValue();
  }

  getTemplateById(templateId: number): Observable<PDFTemplate> {
    return this.http.get<PDFTemplate>(`${this.apiUrl}${templateId}`);
  }

  getAllTemplates(filterParams?: {
    final_product_id?: string,
    category_id?: string,
    category_content_id?: string
  }): Observable<PDFTemplate[]> {
    // No trailing slash before the query: it 301-redirects, costing a round trip.
    let url = this.apiUrl.replace(/\/$/, '');
    if (filterParams) {
      const queryParts = [];
      if (filterParams.final_product_id) {
        queryParts.push(`final_product_id=${filterParams.final_product_id}`);
      }
      if (filterParams.category_id) {
        queryParts.push(`category_id=${filterParams.category_id}`);
      }
      if (filterParams.category_content_id) {
        queryParts.push(`category_content_id=${filterParams.category_content_id}`);
      }
      if (queryParts.length > 0) {
        url = `${url}?${queryParts.join('&')}`;
      }
    }

    // Use get() with a union type because the API might return a single object or an array.
    return this.http.get<PDFTemplate | PDFTemplate[]>(url).pipe(
      map(response => {
        // If the response is already an array, return it as-is.
        if (Array.isArray(response)) {
          return response;
        }
        // If the response is a single object (not an array) and is not null/undefined, wrap it.
        else if (response) {
          return [response];
        }
        return [];
      })
    );
  }


  previewALLPdfs(): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });

    return this.http.get(`${environment.apiLink}/generateAllPdfs`, { headers });
  }

  previewPDF(): Observable<any> {
    return this.http.get(`${environment.apiLink}/previewPDF`);
  }

  ngOnDestroy(): void {

  }

}
